import { api } from '@orisini/ui/lib/api'

export interface BoardDto {
  id: string
  name: string
  privacy: string | null
  imageUrl: string | null
  pinCount: number | null
  manual: boolean
  archived: boolean
}

export const boardsApi = {
  list: (accountId: string) => api.get<{ boards: BoardDto[] }>(`/accounts/${accountId}/boards`),
  syncStatus: (accountId: string) =>
    api.get<{ lastSyncAt: number | null }>(`/accounts/${accountId}/boards/sync-status`),
  sync: (accountId: string) => api.post<{ ok: true }>(`/accounts/${accountId}/boards/sync`),
  create: (accountId: string, name: string) =>
    api.post<{ board: BoardDto }>(`/accounts/${accountId}/boards`, { name }),
}
